import React from 'react';
import ArrowInicio from '../../svg/ArrowInicio';
import RoundButtonArrow from '../RoundButtonArrow';

const ButtonArrow = ({ variant = 'down', onClick = () => { } }) => {
  let rotation = 0;

  if (variant === 'up') {
    rotation = 180;
  } else if (variant === 'left') {
    rotation = 90;
  } else if (variant === 'right') {
    rotation = -90;
  }

  return (
    <RoundButtonArrow rotation={rotation} variant={variant} onClick={onClick} background={'transparent'} color={'#215ccc'}>
      <ArrowInicio />
    </RoundButtonArrow>
  );
};

export default ButtonArrow;
